import React, { Fragment } from "react";
import { CubeIcon } from "@heroicons/react/outline";

function LoadingIndicator(props) {
    return (
        <Fragment>
            <CubeIcon className="spinner d-block mx-auto h-10 w-10 text-gray-300" />
            {props.label ? (
                <div className="mx-auto mt-2 text-center text-xs font-light text-gray-500">
                    {props.label}
                </div>
            ) : (
                ""
            )}
        </Fragment>
    );
}

export default LoadingIndicator;
